// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"f1425b0d","528":"49e66fa8","911":"452561f4"}[chunkId] + ".chunk.js";
};